export function tnCurrentDatetime() {
    return {
        scope: {
            format: '@',
        },
        controller: tnCurrentDatetimeController,
        template: '{{now|date:format}}',
    };
}

function tnCurrentDatetimeController($scope) {
    $scope.now = Date.now();
}
tnCurrentDatetimeController.$inject = ['$scope'];
